const data = require('@kid/Kwai_LA-icon/icon/input/data.json');
const icons = {};
Object.keys(data).map((category) => {
    Object.keys(data[category]).forEach((subType) => {
        const categories = data[category][subType];
        Object.keys(categories).map((key) => {
            icons[key] = data[category][subType][key];
        });
    });
});
export default icons;
